export var RouteName;
(function (RouteName) {
    RouteName["Main"] = "Main";
    RouteName["User"] = "User";
    RouteName["Recharge"] = "Recharge";
    RouteName["Maintenance"] = "Maintenance";
    RouteName["AllStores"] = "AllStores";
    RouteName["AllStoresWithParameter"] = "AllStoresWithParameter";
    RouteName["IqosStores"] = "IqosStores";
    RouteName["PartnerStores"] = "PartnerStores";
    RouteName["ResellerStores"] = "ResellerStores";
    RouteName["Clean"] = "Clean";
    RouteName["Customize"] = "Customize";
    RouteName["Accessories"] = "Accessories";
    RouteName["Engraving"] = "Engraving";
    RouteName["BuyIqos"] = "BuyIqos";
    RouteName["BuyLilSolidEz"] = "BuyLilSolidEz";
    RouteName["BuyHeets"] = "BuyHeets";
    RouteName["BuyTerea"] = "BuyTerea";
    RouteName["BuyFiit"] = "BuyFiit";
    RouteName["BuyVeev"] = "BuyVeev";
    RouteName["BuyZyn"] = "BuyZyn";
    RouteName["New"] = "New";
    RouteName["LendIqos"] = "LendIqos";
    RouteName["Contact"] = "Contact";
    RouteName["SubmitQuestion"] = "SubmitQuestion";
})(RouteName || (RouteName = {}));
